<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { blur } from 'svelte/transition';

    import { api } from '../../../stores/api';
    import { WarehouseApi } from './WarehouseApi';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import WarehouseOne from './WarehouseOne.svelte';
    import { filter } from '../../../stores/filter';
    import MessageFiltered from '../../shared/MessageFiltered.svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import { WarehousesElements } from './WarehousesElements';
    import Separator from '../../shared/Separator.svelte';
    import MessageNotFound from '../../shared/Messages/MessageNotFound.svelte';
    import { defaultWarehouse } from './defaultWarehouse';
    import { type CountType } from '../Vehicles/types';
    import { Warehouse } from './Warehouse';
    import { MapWarehouse } from './MapWarehouse';
    import { VehiclesApi } from '../Vehicles/VehiclesApi';

    export let addMode: boolean = false;
    export let showFilter: boolean = false;
    export let onChange: (w: Warehouse[]) => void = (w: Warehouse[]) => {};

    const compactMode = false;

    let warehouse: Warehouse | null = null;
    let error: string = '';
    let loading: boolean = true;
    let warehousesElements: WarehousesElements | null = null;
    let countTotal: CountType = { count: 0 };

    let expandedIndex: string = '';

    let mapWarehouse: MapWarehouse | null = null;


    onMount(() => {

        mapWarehouse = new MapWarehouse();
        warehousesElements = new WarehousesElements();

        Promise.all([WarehouseApi.getAll(get(api)), VehiclesApi.getAll(get(api)), onMapReady()])
            .then(response => {
                if (warehousesElements) {
                    if (mapWarehouse) {
                        mapWarehouse.setMap(Targeo.Base.Map).addContextMenuItems((coords) => {
                            let w = new Warehouse().set({ ...defaultWarehouse }, null);
                            w.get().geom.coordinates = [
                                coords.x,
                                coords.y,
                            ];
                            w.setName($_('New'));
                            if (warehousesElements) {
                                w.calcAbbreviation(warehousesElements.getWarehouses());
                                warehousesElements.save(w).then(() => {
                                    if (warehousesElements) {
                                        warehousesElements.drawWarehouses();
                                        warehousesElements = warehousesElements;
                                    }
                                }).catch(
                                    (err) => {
                                        console.error(err);
                                    }
                                )
                            } else {
                                console.error('warehousesElements is null in WarehouseList setMap addContextMenuItems');
                            }
                        });
                    }

                    warehousesElements.setWarehouses(
                        response[0].map(function(r) {
                            let v = response[1].filter(v => v.warehouse_id === r.id).map(v => v.id);
                            r = new Warehouse().set(r, r.id);
                            r.setAssignedVehicleIds(v);
                            return r;
                        })
                    );

                    // warehousesElements.drawWarehouses();
                    showFilter = warehousesElements.count() > 0;
                    countTotal = { count: warehousesElements.count() };
                    warehousesElements.drawWarehouses();
                    warehousesElements.zoomToAllWarehouses();
                } else {
                    console.error('warehousesElements is null in WarehouseList onMount');
                }
            })
            .catch(err => {
                error = err.message;
                console.error(err);
            })
            .finally(() => {
                loading = false;
            });

        return () => {
            if (mapWarehouse) {
                mapWarehouse.removeContextMenuItems();
                mapWarehouse = null;
            }
            if (warehousesElements) {
                console.log('warehousesElements.clearMap()');
                warehousesElements.clearMap();
                warehousesElements = null;
            }
        };
    });

    $: {
        if (warehousesElements) {
            console.log('warehousesElements.drawWarehouses() $$$');
            warehouse = warehousesElements.getWarehouseByInnerId(expandedIndex);
            countTotal = { count: warehousesElements.count() };
            warehousesElements.drawWarehouses();
            onChange(warehousesElements.getWarehouses());
        }
        if (addMode) {
            warehouse = new Warehouse().set({ ...defaultWarehouse }, null);
        }
    }
</script>

{#if loading}
    <Spinner />
{:else if addMode}
    <main style="margin-bottom: 20px;">
        <div data-type="new" style="width: 100%;">
            {#if warehouse && warehousesElements}
                <WarehouseOne {warehouse} bind:warehousesElements bind:addMode />
            {/if}
        </div>
    </main>
{:else if error}
    <MessageDanger {error} />
{:else}
    {#if !compactMode && warehousesElements}
        <MessageFiltered
            filteredCount={warehousesElements.filter($filter.warehouses.query).length}
            totalCount={countTotal.count}
        />
    {/if}
    {#if countTotal.count === 0}
        <MessageNotFound text={$_('no_warehouses')} />
    {:else}
        <Separator />
        {#if warehousesElements}
            <div class="warehouse-list">
                {#each warehousesElements.filter($filter.warehouses.query) as warehouse, index (warehouse.innerId)}
                    <div out:blur>
                        <WarehouseOne
                            showHeader={index === 0}
                            {warehouse}
                            bind:warehousesElements
                            bind:expandedIndex
                        />
                    </div>
                {:else}
                    <div
                        style="display: flex; justify-content: center; align-items: center; flex-direction: column; padding: 30px;"
                    >
                        <MessageNotFound text={$_('no_filtered_vehicles')} />
                    </div>
                {/each}
            </div>
        {/if}
    {/if}
{/if}

<style>
    main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        /*background-color: var(--section-background);*/
        width: auto;
        height: auto;
        border-radius: 10px;
        padding: 15px;
        row-gap: 3px;
    }
    .warehouse-list {
        overflow-y: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
</style>
